[
  {
    "code": "BZ-BZ",
    "name": "Belize"
  },
  {
    "code": "BZ-CY",
    "name": "Cayo"
  },
  {
    "code": "BZ-CZL",
    "name": "Corozal"
  },
  {
    "code": "BZ-OW",
    "name": "Orange Walk"
  },
  {
    "code": "BZ-SC",
    "name": "Stann Creek"
  },
  {
    "code": "BZ-TOL",
    "name": "Toledo"
  }
]